import { Combobox } from "../../../components/ui";
import type { AssignableUser } from "../services/serviceDeskService";

interface SelectOption {
  value: string;
  label: string;
}

interface AgentSelectorProps {
  value: string | null | undefined;
  onChange: (agentId: string | null) => void;
  isDarkMode: boolean;
  users: AssignableUser[];
  placeholder?: string;
  isClearable?: boolean;
  isDisabled?: boolean;
  /** Nombre a mostrar si `value` no está entre `users` (p. ej. un agente de ejemplo del Sandbox). */
  fallbackName?: string | null;
}

export function AgentSelector({
  value,
  onChange,
  users,
  placeholder = "Seleccionar agente...",
  isClearable = true,
  isDisabled = false,
  fallbackName = null,
}: AgentSelectorProps) {
  const options: SelectOption[] = users.map((u) => ({
    value: u.id,
    label: u.name,
  }));
  if (value && fallbackName && !options.some((o) => o.value === value)) {
    options.unshift({ value, label: fallbackName });
  }

  const selectedOption = options.find((opt) => opt.value === value) ?? null;

  return (
    <Combobox<SelectOption>
      value={selectedOption}
      onChange={(option) => onChange(option?.value ?? null)}
      options={options}
      placeholder={placeholder}
      isSearchable
      isClearable={isClearable}
      isDisabled={isDisabled}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      noOptionsMessage={() => "Sin agentes disponibles"}
      menuPortalTarget={document.body}
      menuPosition="fixed"
    />
  );
}
